import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  title: {
    textTransform: 'uppercase',
    color: theme.palette.action.main,
  },
  subtitle: {
    fontSize: 13,
  },
}));
